import { cn } from '../../utils/classNames';
import XAutoGrowTextarea from './XAutoGrowTextarea';
import XButton from './XButton';
import { copyTextToClipboard } from "../../utils/helper";

const labelClasses = 'block mb-2 text-content font-sans';

const wrapperClasses = 'relative w-full';

const textareaBaseClasses = `
  block w-full px-3 py-2
  font-sans text-base text-content
  bg-white border border-border rounded-md
  resize-none overflow-hidden transition-colors
  focus:outline-none focus:ring-2 focus:ring-primary-ring focus:border-primary
  disabled:opacity-60 disabled:cursor-not-allowed
`;

const copyButtonClasses =
  'absolute bottom-2.5 right-0.5 min-w-7.5 h-7.5';

const XResizableTextarea = ({
  label,
  value,
  className,
  minHeight = '7rem',
  copyButton = false,
  ...props
}) => {

  return (
    <>
      {label && <label className={labelClasses}>{label}</label>}
      <div className={wrapperClasses}>
        <XAutoGrowTextarea
          value={value}
          minHeight={minHeight}
          className={cn(textareaBaseClasses, copyButton && 'pr-10!', className)}
          {...props}
        />

        {copyButton && (
          <XButton
            variant="close"
            onClick={() => copyTextToClipboard(value)}
            className={copyButtonClasses}
            aria-label="Copy text"
          >
            <i className="fa fa-copy" />
          </XButton>
        )}
      </div>
    </>
  );
};

export default XResizableTextarea;
